var map = {
	"./da.webp": 31555,
	"./de.webp": 9471,
	"./en.webp": 60567,
	"./es-419.webp": 19523,
	"./es.webp": 55424,
	"./fr.webp": 41524,
	"./it.webp": 24813,
	"./nb.webp": 6028,
	"./nl.webp": 83930,
	"./pl.webp": 95392,
	"./pt.webp": 72184,
	"./sv.webp": 70813,
	"./tr.webp": 43938
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5663;